<template>
    <oss-dialog
        v-if="deleteAuditCheckResultDialog"
        v-model="deleteAuditCheckResultDialog"
        withoutHeader="true"
        valid-title="Valider"
        :valid-loading="deleteAuditCheckResultLoading"
        @valid="deleteAuditCheckResults()"
        @close="close()"
        min-width="45vw"
    >
        <v-alert border="start" border-color="red" class="py-4 mb-0">
            <h3 class="text-center">&#xca;tes vous sûr de vouloir supprimer ce contrôle ?</h3>
        </v-alert>
    </oss-dialog>
</template>

<script lang="ts">
import DELETE_AUDIT_CHECK_RESULTS_AND_RESULTS from "../../graphql/audit/DeleteAuditCheckResultIds.gql";
import { Component, Vue, toNative } from "vue-facing-decorator";
import { Prop } from "vue-facing-decorator";
import { Model } from "vue-facing-decorator";

@Component({
    components: {},
    emits: ["closed", "deletedAcr"],
})
export class AuditDeleteAuditCheckResultDialog extends Vue {
    @Prop({ default: "" }) readonly title: string;
    @Prop({ default: null }) auditCheckResultId: any;
    @Prop({ default: undefined }) nestedAuditCheckResults: Array<any>;

    @Model({ default: false }) deleteAuditCheckResultDialog: boolean;

    deleteAuditCheckResultLoading: boolean = false;

    close() {
        this.$emit("closed", true);
    }

    async deleteAuditCheckResults() {
        this.deleteAuditCheckResultLoading = true;
        // //////////////////////////////////////////////////////
        // ** nestedAuditCheckResults are used by cutPrevious
        // ** don't send a unique list: it will bug
        // ** delete first nestedAuditCheckResults then delete global auditCheckResult
        // //////////////////////////////////////////////////////
        let deletedNestedACR;
        if (this.nestedAuditCheckResults?.length) {
            if (this.nestedAuditCheckResults.length > 10) {
                // ** to avoid timeout
                for (let i = 0; i < this.nestedAuditCheckResults.length; i += 10) {
                    // ** by group of 10 or less
                    const nestedACRsGroup = this.nestedAuditCheckResults.slice(i, i + 10);

                    try {
                        deletedNestedACR = await this.$apollo.mutate({
                            mutation: DELETE_AUDIT_CHECK_RESULTS_AND_RESULTS,
                            variables: { ids: nestedACRsGroup },
                        });
                    } catch (error) {
                        deletedNestedACR = null;
                        console.error(error);
                        debugger;
                    }
                }
            } else {
                try {
                    deletedNestedACR = await this.$apollo.mutate({
                        mutation: DELETE_AUDIT_CHECK_RESULTS_AND_RESULTS,
                        variables: { ids: this.nestedAuditCheckResults },
                    });
                } catch (error) {
                    deletedNestedACR = null;
                    console.error(error);
                    debugger;
                }
            }
        }

        if (
            (this.nestedAuditCheckResults && deletedNestedACR) ||
            !this.nestedAuditCheckResults?.length
        ) {
            try {
                const deletedAuditCheckResult = await this.$apollo.mutate({
                    mutation: DELETE_AUDIT_CHECK_RESULTS_AND_RESULTS,
                    variables: { ids: [this.auditCheckResultId] },
                });

                if (deletedAuditCheckResult) {
                    this.$emit("deletedAcr");
                }

                // ** backend getGeneralLedger in getItems do await gl.computeCarryForward()
                // await this.computeCarryForward()
            } catch (error) {
                console.error(error);
                debugger;
            }
        }
        this.deleteAuditCheckResultLoading = false;
    }
}

export default toNative(AuditDeleteAuditCheckResultDialog);
</script>
